import { gql } from '@apollo/client';

export const UPDATE_DELEGACION_PACIENTE = gql`
  mutation UpdateDelegacionPacienteContrato($idPaciente: Int!, $idEvaluacion: Int, $idDelegacion: Int!) {
    updateDelegacionPacienteContrato(idPaciente: $idPaciente, idEvaluacion: $idEvaluacion, idDelegacion: $idDelegacion) {
      success  
      error
      valorEsperado{
        idPaciente
      }
    }
  }
`;

export const UPDATE_NOMBRE_PACIENTE = gql`
  mutation UpdateNombrePaciente($idPaciente: Int!, $nombre: String!, $apellido: String!) {
    updateNombrePaciente(idPaciente: $idPaciente, nombre: $nombre, apellido: $apellido) {
      success  
      error
      valorEsperado{
        idPaciente
      }
    }
  }
`;

export const UPDATE_NUMERO_DOCUMENTO_PACIENTE = gql`
  mutation UpdateNumeroDocumentoPaciente($idPaciente: Int!, $numeroDocumento: String!) {
    updateNumeroDocumentoPaciente(idPaciente: $idPaciente, numeroDocumento: $numeroDocumento) {
      success  
      error
      valorEsperado{
        idPaciente
      }
    }
  }
`;

export const UPDATE_FECHA_NACIMIENTO_PACIENTE = gql`
  mutation UpdateFechaNacimientoPaciente($idPaciente: Int!, $fechaNacimiento: CustomDateTime!) {
    updateFechaNacimientoPaciente(idPaciente: $idPaciente, fechaNacimiento: $fechaNacimiento) {
      success  
      error
      valorEsperado{
        idPaciente
      }
    }
  }
`;

export const DESVINCUAL_PACIENTE_SAP = gql`
  mutation DesvincualPacienteSAP($idPaciente: Int!) {
    desvincualPacienteSAP(idPaciente: $idPaciente) {
      success  
      error
      valorEsperado{
        idPaciente
      }
    }
  }
`;
